import { mdiCheckDecagram } from '@mdi/js'
import Icon from '@mdi/react'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IApproval } from '@/types/tasksApprovals'

import ApprovalItem from '../../item/approval'
import SystemIcon from '../../systemIcon'

interface IProps {
    approvals: IApproval[]
}

const ApprovalsList = ({ approvals }: IProps) => {
    const color = useColorModeValue('rgba(84, 79, 64, 0.7)', 'rgba(255, 255, 255, 0.7)')

    return (
        <Box pr="24px" pt="16px">
            <Flex alignItems="center">
                <Icon path={mdiCheckDecagram} size="16px" color={color} />
                <Text pl="8px" fontSize="14px" fontWeight="bold" lineHeight="20px" color={color}>
                    APPROVAL REQUESTS
                </Text>
            </Flex>
            {approvals.map((approval) => (
                <ApprovalItem item={approval} key={approval.approval_entity_id} icon={<SystemIcon system={approval.system_id} />} />
            ))}
        </Box>
    )
}

export default ApprovalsList
